import { PureComponent } from 'preact-compat'
import Button from '../../../control-components/ui-components/Button'
import Phrase from '../../../libs/translationsUtils/phrase'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../modal'

export interface PrivateMessageReportedModalProps {
  onIUnderstand: () => void
}

class PrivateMessageReportedModal extends PureComponent<PrivateMessageReportedModalProps> {
  render() {
    const { onIUnderstand } = this.props
    return (
      <Modal isOpen size='medium'>
        <ModalHeader
          title={<Phrase p='privateMessages.reportSuccessModal.title' />}
          onClose={onIUnderstand}
        />
        <ModalBody>
          <Phrase p='privateMessages.reportSuccessModal.text' />
        </ModalBody>
        <ModalFooter>
          <Button onClick={onIUnderstand}>
            <Phrase p='privateMessages.reportSuccessModal.button' />
          </Button>
        </ModalFooter>
      </Modal>
    )
  }
}

export default PrivateMessageReportedModal
